import * as Enumerable from 'linq';
import { DateTime } from 'luxon';

export interface DateFormat {
    id: string;
    name: string;
}

export interface DateFormatGroup {
    name: string;
    formats: DateFormat[];
}


export class DateFormatUtility {

    public static getDateFormats(seperator = '/'): DateFormat[] {

        const mediumFormats = [
            'dd.MM.yyyy',
            'MM.dd.yyyy',
            'yyyy.MM.dd'
        ];

        return Enumerable
            .from(mediumFormats)
            .select(x => {
                const formatted = this.replaceAll(x, '.', seperator);
                return {
                    id: formatted,
                    name: formatted
                };
            }).toArray();

    }

    public static getDefaultDateFormat(seperator = '/') {
        return Enumerable.from(this.getDateFormats(seperator)).select(x => x.id).firstOrDefault();
    }

    /** Dropdown labels for the format ids. The sample is today, so the settings screen and the config endpoint stay on one builder. */
    public static getDateFormatChoices(seperator = '/', now: DateTime = DateTime.local()): DateFormat[] {

        return this.getDateFormats(seperator).map(format => ({
            id: format.id,
            name: `${format.id} [ ${now.toFormat(format.id)} ]`,
        }));
    }

    public static getTimeFormats(): DateFormat[] {

        const mediumFormats = [
            'hh:mm a',
            'HH:mm'
        ];

        return Enumerable
            .from(mediumFormats)
            .select(x => {
                return {
                    id: x,
                    name: x
                };
            }).toArray();

    }

    public static getDefaultTimeFormat() {
        return Enumerable.from(this.getTimeFormats()).select(x => x.id).firstOrDefault();
    }

    /** Dropdown labels for the time format ids. `a` means 12-hour; the sample is the current time. */
    public static getTimeFormatChoices(now: DateTime = DateTime.local()): DateFormat[] {

        return this.getTimeFormats().map(format => ({
            id: format.id,
            name: `${format.id.includes('a') ? '12-hour' : '24-hour'} [ ${now.toFormat(format.id)} ]`,
        }));
    }

    private static replaceAll(data: string, find: string, replace: string) {
        return data.split(find).join(replace);
    }

}
